import { Action, Dispatch } from "redux";
import * as constants from "./constants";
import { IState, IWatchlist, IFundFilterResponse, IShareClassFilterResponse, IFilterRequest, IAppParams } from "../models";
import { Actions } from "./models";
import { isNullOrUndefined, addItemToGoogleTracking, getViewFundList } from "../utils";

const storageIdentifier = "MGWatchlist";

export function watchlistInit() {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let watchlistStorage = JSON.parse(localStorage.getItem(storageIdentifier)) || [];
        let responseAction: Actions = {
            type: constants.GET_WATCHLIST,
            payload: watchlistStorage
        };

        dispatch(responseAction);
    };
}

export function editWatchlist(watchlistItems: IWatchlist, appParams: IAppParams, isRemove = false, isFundPage = false) {
    return async (dispatch: Dispatch<IState>, getState: () => IState) => {
        let fundList = getViewFundList(appParams);
        let watchlistStorage = JSON.parse(localStorage.getItem("MGWatchlist")) || [];
        let index = watchlistStorage.map((item, i) => {
            if (item.isin === watchlistItems.isin && fundList === item.fundList) {
                return i;
            }
        }).filter((item) => !isNullOrUndefined(item))[0];

        if (index >= 0 || isNullOrUndefined(index)) {
            if (isFundPage) {
                addItemToGoogleTracking(appParams, isRemove ? "removefromwatchlistFundPage" : "addtowatchlistFundPage", { eventCategory: watchlistItems.isin, eventLabel: isRemove ? 'Fund Page-Watchlist_Remove' : 'Fund Page-Watchlist_Add' });
            }
            else {
                addItemToGoogleTracking(appParams, isRemove ? "removefromwatchlist" : "addtowatchlist", { eventCategory: watchlistItems.isin, eventLabel: isRemove ? 'Fund Explorer-Watchlist_Remove' : 'Fund Explorer-Watchlist_Add' });
            }

            if (isRemove) {
                watchlistStorage.splice(index, 1);
            } else {
                watchlistStorage.push({ ...watchlistItems, fundList });
            }
            localStorage.setItem(storageIdentifier, JSON.stringify(watchlistStorage))
        }

        let responseAction: Actions = {
            type: constants.ADD_TO_WATCHLIST,
            payload: watchlistStorage
        };

        dispatch(responseAction);
    };
}


// WEBPACK FOOTER //
// ./src/client/actions/watchlist.ts